import Component from '_core_ext/components/Component';
import eventMgr from '_core_ext/eventMgr';

const emitter = eventMgr.getEmitter('stripecreditcard');

export default class StripeCreditCard extends Component {
    init() {
        super.init();

        this.stripePublicKey = this.$el.data('stripe-public-key');

        this.event('click', '.js-cancel-button', this.closeDialog);
        this.event('click', '.js-apply-button', this.addCard);

        if (window.Stripe) {
            this.stripe = Stripe(this.stripePublicKey);
            this.stripeElements = this.stripe.elements();
            this.initStripeCardElement();
        }
    }

    initStripeCardElement() {
        const cardElementOptions = {
            style: this.$el.data('element-style'),
            hidePostalCode: true,
            iconStyle: 'solid'
        };

        this.cardElement = this.stripeElements.create('card', cardElementOptions);
        this.cardElement.mount('#card-element');
    }

    addCard() {
        let $form = this.$el;
        // https://stripe.com/docs/payments/payment-methods/saving
        this.stripe.createPaymentMethod('card', this.cardElement, {
            allow_redisplay: 'always'
        }).then(function (result) {
            if (result.error) {
                alert(result.error.message);
            } else {
                var paymentMethodId = result.paymentMethod.id;
                $.ajax({
                    url: $form.attr('action'),
                    method: 'POST',
                    data: {
                        payment_method_id: paymentMethodId,
                        csrf_token: $form.find('[name="csrf_token"]').val()
                    }
                }).done(function (msg) {
                    if (msg.success) {
                        location.reload();
                    } else {
                        alert(msg.error);
                    }
                }).fail(function (msg) {
                    if (msg.responseJSON.redirectUrl) {
                        window.location.href = msg.responseJSON.redirectUrl;
                    } else {
                        alert(msg);
                    }
                });
            }
        });
    }

    closeDialog() {
        emitter.emit('close');
    }
}
